import logoDark from "../images/logo_dark.svg";
import logo from "../images/doer_logo.svg";

const COLORS = {
    light: {
        black: "#3E3E3E",
        lightText: "#bababa",
        transparentOverlay: "rgba(255,255,255,0.8)",
        modalBackground: "#3E3E3E",
        primary: "#34AFF3",
        red: "#e01f5c",
        white: "#ffffff",
        defaultGradient: {
            color1: "#68E0CF",
            color2: "#209CFF"
        },
        iconGradient: {
            color1: "#CECFD0",
            color2: "#F0F0F0"
        }
    },
    dark: {
        black: "#ffffff",
        lightText: "rgba(255,255,255,0.2)",
        transparentOverlay: "rgba(62,62,62,0.8)",
        modalBackground: "rgba(0,0,0,0.9)",
        primary: "#34AFF3",
        red: "#fa3126",
        white: "#3E3E3E",
        defaultGradient: {
            color1: "#68E0CF",
            color2: "#209CFF"
        },
        iconGradient: {
            color1: "#CECFD0",
            color2: "#F0F0F0"
        }
    }
};

const GLOBAL = (colors) => {
    return {
        h1: {
            fontSize: 28,
            fontWeight: "700"
        },
        screenContainer: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%"
        },
        pro: {
            backgroundColor: colors.black,
            width: 30,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: 20,
            borderRadius: 5,
            marginTop: 2,
            fontSize: 10,
            fontWeight: "700",
            marginLeft: 6,
            color: colors.white
        },
        label: {
            textTransform: "uppercase",
            fontSize: 13,
            marginLeft: 2,
            marginBottom: 8,
            fontWeight: "700",
            opacity: 0.3
        }
    }
};

const GRADIENTS = {
    line: "linear-gradient(90deg, #68E0CF 0%, #209CFF 100%)"
};

const IMAGES = {
    dark: {
        logo: logoDark
    },
    light: {
        logo: logo
    }
}

export default {
    getStyle(mode) {
        // Need to get the mode here

        return {
            colors: COLORS[mode],
            global: GLOBAL(COLORS[mode]),
            gradients: GRADIENTS,
            images: IMAGES[mode]
        };
    }

    
};


// WEBPACK FOOTER //
// ./src/style/Style.js